import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";

const routes = [
    {
        name: 'login',
        path: '/',
        component: () => import('@/views/LogIn'),
    },
    {
        name: 'ask_name',
        path: '/hello',
        component: () => import('@/views/AskName'),
    },
    {
        name: 'media_viewer',
        path: '/media',
        component: () => import('@/views/MediaViewer'),
    },
    {
        name: 'done',
        path: '/done',
        component: () => import('@/views/Done'),
    },
    {
        name: '404',
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/NotFound'),
    }
]

export const history = createWebHistory()

const router = createRouter({history, routes})

router.beforeEach((to) => {
    if (!store.state.auth.token && to.name !== 'login') {
        return {name: 'login'};
    }
})

export default router;
